var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cateInfo",on:{"click":_vm.goToCategory}},[_c('div',{staticClass:"thumb"},[_c('img',{attrs:{"src":_vm.cateInfo.thumbnail,"alt":_vm.getCateName}})]),_c('div',{staticClass:"content"},[_c('img',{attrs:{"src":_vm.cateInfo.embed_icon,"alt":_vm.getCateName}}),_c('span',{domProps:{"textContent":_vm._s(_vm.getCateName)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }